module.exports = __webpack_public_path__ + "static/media/assa-clock.84522c65.svg";